import { reelsTotalTimeWatchedConfig } from '@/lib/analytics/kpis/instagram/reels/reelsTotalTimeWatched';
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const reelsTotalTimeWatchedMVConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof MediaViewerKPI
> = {
    ...reelsTotalTimeWatchedConfig,
    id: 'total_time_watched',
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
